import { useEffect } from "react";

export default function CookiePolicy() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://app.termly.io/embed-policy.min.js";
    script.id = "termly-jssdk";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="terms-container">
      <div
        name="termly-embed"
        data-id="9639ad67-cfe2-48f3-886d-370b10d584d2"
      ></div>
    </div>
  );
}
